import * as React from 'react';

import { ELandStatusType } from '../../../../../../../json_query';
import { FOfferType } from '../../../../../../../utils/category';
import { getArrayChange } from '../../../../../../../utils/arrayChange';
import { DropdownField } from '../../../components/dropdownField';

export interface ILandStatusProps {
  offerType: FOfferType;
  value: ELandStatusType[];
  onChange(status: ELandStatusType, value: boolean | undefined): void;
}

interface ILandStatus {
  label: string;
  value: ELandStatusType;
}

const VALUES: ILandStatus[] = [
  { label: 'Фермерское хозяйство', value: ELandStatusType.Farm },
  { label: 'Личное подсобное хозяйство', value: ELandStatusType.PrivateFarm },
  { label: 'Садоводство', value: ELandStatusType.Gardening },
  { label: 'ИЖС', value: ELandStatusType.IndividualHousingConstruction },
  { label: 'Земля промназначения', value: ELandStatusType.IndustrialLand },
  { label: 'ДНП', value: ELandStatusType.CountryhouseNonCommercialPartnership },
];

const LAND_VALUES: ILandStatus[] = [{ label: 'Инвестпроект', value: ELandStatusType.InvestmentProject }];

export const LandStatus: React.StatelessComponent<ILandStatusProps> = ({ offerType, value, onChange }) => (
  <DropdownField
    multiple
    placeholder="Любой"
    value={value.concat()}
    onValueChange={(statuses: ELandStatusType[]) => onChange(...getArrayChange(value, statuses))}
    values={VALUES.concat(offerType === FOfferType.Land ? LAND_VALUES : [])}
  />
);
